<template>
  <div>
    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="
          $t('components.inmemorystores.delete_store_{0}', [
            trans(editedItem, 'Name'),
          ])
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" persistent max-width="800px">
      <material-card
        :title="
          editedIndex > -1
            ? $t('components.inmemorystores.edit_store_{0}', [
                trans(editedItem, 'Name'),
              ])
            : $t('components.inmemorystores.create_new_store')
        "
        :color="formColor"
        :icon="formIcon"
        v-if="editedItem !== null && editedItem !== undefined"
      >
        <v-card-text>
          <v-dialog v-model="cancelDialog" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">
                {{ $t("globals.cancel_wizard") }}
              </v-card-title>
              <v-card-text>
                {{
                  $t(
                    "components.inmemorystores.if_you_exit_the_wizard_any_changes_made_so_far"
                  )
                }}
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="cancelDialog = false">
                  {{ $t("globals.keep_working") }}
                </v-btn>
                <v-btn color="primary" text @click="cancelWizard()">
                  {{ $t("globals.cancel_anyway") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-row>
            <v-stepper
              v-model="e6"
              vertical
              class="elevation-0"
              v-if="editedItem !== null && editedItem !== undefined"
            >
              <v-stepper-step
                :complete="e6 > 1"
                step="1"
                :editable="editedIndex > -1"
              >
                {{ $t("components.inmemorystores.store_info") }}
                <small>
                  {{ $t("components.inmemorystores.fill_in_the_fields") }}
                </small>
              </v-stepper-step>

              <v-stepper-content step="1">
                <v-container>
                  <v-row>
                    <v-col>
                      <v-form
                        ref="storeInfoForm"
                        v-model="valid.info"
                        v-if="
                          this.editedItem !== null &&
                            this.editedItem !== undefined
                        "
                      >
                        <v-container fluid>
                          <v-row>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <trans-textbox
                                v-model="editedItem"
                                :label="$t('globals.name')"
                                :rules="[$rules.required, rules.uniqueName]"
                                field="Name"
                                :dialog="editDialog"
                                class="required"
                              ></trans-textbox>
                            </v-col>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.Number"
                                :label="$t('globals.number')"
                                :rules="[
                                  $rules.required,
                                  $rules.numeric,
                                  $rules.dynamic.upToLength(4),
                                  $rules.notOnlyFourZeros,
                                ]"
                                class="required"
                              ></no-autocomplete-textfield>
                            </v-col>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <trans-select
                                :item="editedItem"
                                propertyName="Status"
                                :items="options.Models.ParticipationStatus"
                                :label="$t('globals.status')"
                                :rules="[$rules.required]"
                                class="required"
                              ></trans-select>
                            </v-col>
                            <v-col
                              xs="12"
                              sm="6"
                              md="4"
                              lg="4"
                              v-if="hasBillingImport"
                            >
                              <v-checkbox
                                v-model="editedItem.IsAssignable"
                                v-bind:false-value="true"
                                v-bind:true-value="false"
                                :label="
                                  $t('components.inmemorystores.is_corporate')
                                "
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
                <v-btn
                  v-if="editedItem.IsAssignable !== false"
                  color="primary"
                  @click="e6 = 2"
                  :disabled="!valid.info"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step
                v-if="editedItem.IsAssignable !== false"
                :complete="e6 > 2"
                step="2"
                :editable="editedIndex > -1"
              >
                {{ $t("components.inmemorystores.store_contact_details") }}
                <small>
                  {{ $t("components.inmemorystores.fill_in_the_fields") }}
                </small>
              </v-stepper-step>

              <v-stepper-content
                step="2"
                v-if="editedItem.IsAssignable !== false"
              >
                <v-container>
                  <v-row>
                    <v-col>
                      <v-form
                        ref="storeDetailsForm"
                        v-model="valid.details"
                        v-if="
                          this.editedItem !== null &&
                            this.editedItem !== undefined
                        "
                      >
                        <v-container fluid>
                          <v-row>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.PhoneNumber"
                                :label="
                                  $t('globals.telephone')
                                "
                                required
                                :rules="[rules.phone]"
                                v-mask="telephoneMask"
                              ></no-autocomplete-textfield>
                              <no-autocomplete-textfield
                                v-model="editedItem.PhoneNumber2"
                                :label="
                                  $t('globals.telephone') +
                                    ' 2'
                                "
                                required
                                :rules="[rules.phone]"
                                v-mask="telephoneMask"
                              ></no-autocomplete-textfield>
                              <!-- <no-autocomplete-textfield
                                v-model="editedItem.PhoneNumber"
                                :label="
                                  $t('globals.telephone')
                                "
                                required
                                :rules="[$rules.phone]"
                              ></no-autocomplete-textfield> -->
                            </v-col>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.Fax"
                                :label="
                                  $t('globals.fax_number')
                                "
                                required
                                :rules="[rules.phone]"
                                v-mask="telephoneMask"
                              ></no-autocomplete-textfield>
                              <!-- <no-autocomplete-textfield
                                v-model="editedItem.Fax"
                                :label="
                                  $t('globals.fax_number')
                                "
                                required
                                :rules="[$rules.phone]"
                              ></no-autocomplete-textfield> -->
                            </v-col>
                            <v-col xs="12" sm="6" md="4" lg="4">
                              <no-autocomplete-textfield
                                v-model="editedItem.Email"
                                :label="$t('headers.contacts.email')"
                                required
                                :rules="[$rules.email]"
                              ></no-autocomplete-textfield>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
                <v-btn text @click="e6 = 1">
                  {{ $t("globals.back") }}
                </v-btn>
                <v-btn
                  v-if="editedItem.IsAssignable !== false"
                  color="primary"
                  @click="continueToAddress()"
                  :disabled="!valid.details"
                >
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>

              <v-stepper-step
                v-if="editedItem.IsAssignable !== false"
                :complete="e6 > 3"
                step="3"
                :editable="editedIndex > -1"
              >
                {{ $t("components.inmemorystores.store_address") }}
                <small>
                  {{
                    $t("components.inmemorystores.add_address_to_this_store")
                  }}
                </small>
              </v-stepper-step>
              <v-stepper-content
                step="3"
                v-if="editedItem.IsAssignable !== false"
              >
                <!-- <v-container> -->
                <!-- <address-form
                    ref="address"
                    :provinces="options.Models.Province"
                    :item="editedItem"
                    v-if="editedItem"
                  ></address-form> -->
                <canada-post-address
                  :address="editedItem.Address"
                  @update-address="editedItem.Address = $event"
                  @valid="valid.address=$event"
                />
                <!-- </v-container> -->
                <v-btn text @click="addressBack">
                  {{ $t("globals.back") }}
                </v-btn>
                <v-btn color="primary" @click="e6 = 4" :disabled="!valid.address">
                  {{ $t("globals.continue") }}
                </v-btn>
              </v-stepper-content>
              <v-stepper-step
                v-if="editedItem.IsAssignable !== false"
                :complete="e6 > 4"
                step="4"
                :editable="editedIndex > -1"
              >
                {{ $t("components.inmemorystores.store_contacts") }}
                <small>
                  {{
                    $t("components.inmemorystores.add_contacts_to_this_store")
                  }}
                </small>
              </v-stepper-step>
              <v-stepper-content
                step="4"
                v-if="editedItem.IsAssignable !== false"
              >
                <contacts
                  :contacts="editedItem.Contacts"
                  identifier="inMemoryStoresContacts"
                  @contacts-changed="editedItem.Contacts = $event"
                  :planIdentityId="planIdentityId"
                ></contacts>
                <v-btn text @click="contactsBack">
                  {{ $t("globals.back") }}
                </v-btn>
                <!--v-btn
                  color="primary"
                  @click="e6 = 4"
                  :disabled="!addressValid()"
                >{{$t('globals.continue')}}</v-btn-->
              </v-stepper-content>
            </v-stepper>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancelDialog = true">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :disabled="!allValid()" color="primary" @click="save">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <material-card
    :title="$t('globals.stores')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="store"
    >
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="contacts"
        @itemsChanged="setData($event)"
        :identifier="identifier"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
// import AddressForm from "@/components/AddressForm";
import ErrorHandler from "@/components/ErrorHandler";
import InMemoryStoresHeaders from "@/headers/InMemoryStores";
import InMemoryStoresBillingImportHeaders from "@/headers/InMemoryStoresBillingImport";
import TransTextbox from "@/components/TransTextbox";
import { translate2 } from "@/trans2";
import Contacts from "@/components/PlanBuilder/Contacts";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { tokens, mask } from "vue-the-mask";
import masker from "vue-the-mask/src/masker";
import CanadaPostAddress from "@/components/CanadaPostAddress";
import TransSelect from "@/components/TransSelect";
export default {
  components: {
    // AddressForm,
    ErrorHandler,
    TransTextbox,
    Contacts,
    NoAutocompleteTextfield,
    CanadaPostAddress,
    TransSelect
  },
  props: [
    "stores",
    "identifier",
    "planIdentityId",
    "hasBillingImport",
    "disabled",
  ],
  directives: { mask },
  data() {
    return {
      rules: {
        phone: (v) => {
          let val = this.unmask(v, this.telephoneMask);
          return !val || this.$rules.phone(val);
        },
        uniqueName: (v) => {
          let existing = this.provider.items.filter((o) => o.Name === v);
          let valid = true;
          if (existing.length === 0) {
            return true;
          }
          valid =
            existing.filter((o) => o.Identifier === this.editedItem.Identifier)
              .length === 1;
          return valid || this.$t("validation.name_must_be_unique");
        },
      },
      telephoneMask: "(###) ### - ####",
      error: null,
      valid: {
        details: false,
        info: false,
        address: true
      },
      cancelDialog: false,
      items: [],
      confirmDeactivateDialog: false,
      confirmActivateDialog: false,
      deleteDialog: false,
      provider: undefined,
      statuses: [],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.editItem({
              Contacts: [],
              Translations: [],
              Identifier: Math.random().toString(),
            });
          },
          visible: () => !this.disabled,
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
          visible: () => !this.disabled,
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            const o = this.provider.items.filter(
              (o) => o.Identifier === item.Identifier
            )[0];
            this.editedIndex = this.provider.items.indexOf(o);
            this.editedItem = item;
            this.deleteDialog = true;
          },
          visible: () => !this.disabled,
        },
      ],
      e6: 1,
      editDialog: false,
      headers: InMemoryStoresHeaders,
      editedIndex: -1,
      editedItem: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    formIcon() {
      return this.editedIndex === -1 ? "add" : "edit";
    },
    formColor() {
      return this.editedIndex === -1 ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    stores: {
      handler(v) {
        if (v) {
          if (this.provider) {
            this.provider.items = v;
            this.$refs.table.getDataAsync();
          }
        }
      },
    },
    hasBillingImport: {
      handler(v) {
        if (v) {
          this.headers = InMemoryStoresBillingImportHeaders;
          this.provider = new InMemoryProvider(this.stores, this.headers);
          if (this.$refs.table) {
            this.$refs.table.getDataAsync();
          }
        } else {
          if (this.provider !== null && this.provider !== undefined) {
            for (let store of this.provider.items) {
              store.IsAssignable = false;
            }
            this.$emit("changed", this.provider.items);
          }
          this.$nextTick(() => {
            this.headers = InMemoryStoresHeaders;
            this.provider = new InMemoryProvider(this.stores, this.headers);
            if (this.$refs.table) {
              this.$refs.table.getDataAsync();
            }
          });
        }
      },
    },
  },
  mounted() {
    if (this.hasBillingImport) {
      this.headers = InMemoryStoresBillingImportHeaders;
    }
    this.provider = new InMemoryProvider(this.stores, this.headers);
  },
  methods: {
    unmask(v, mask) {
      if (v) {
        return masker(v, mask, false, tokens);
      }
      return v;
    },
    trans(item, field) {
      return translate2(item, field);
    },
    continueToAddress() {
      if (this.$refs.address) {
        this.$refs.address.resetValidation();
      }
      this.e6 = 3;
    },
    addressBack() {
      if (this.$refs.address) {
        this.$refs.address.resetValidation();
      }
      this.e6 = 2;
    },
    contactsBack() {
      this.e6 = 3;
    },
    allValid() {
      if (!this.editedItem) return false;
      return this.valid.info && this.valid.details && this.valid.address;
    },
    cancelWizard() {
      this.$refs.storeInfoForm.resetValidation();
      if (this.$refs.storeDetailsForm)
        this.$refs.storeDetailsForm.resetValidation();
      this.cancelDialog = false;
      this.editDialog = false;
      this.editedItem = null;
      this.editedIndex = -1;
    },
    reload() {
      this.$refs.table.getDataAsync();
    },
    setData(items) {
      this.items = items;
    },
    saveHeaders(headerscopy) {
      this.headers = JSON.parse(JSON.stringify(headerscopy));
    },
    validate() {
      if (this.$refs.form && this.$refs.form.validate()) {
        return true;
      }
      return false;
    },
    async editItem(item) {
      let con;
      con = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];
      this.editedIndex = this.provider.items.indexOf(con);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.e6 = 1;
      this.editDialog = true;
    },
    close() {
      this.$refs.storeInfoForm.resetValidation();
      if (this.$refs.storeDetailsForm)
        this.$refs.storeDetailsForm.resetValidation();
      this.editDialog = false;
      this.editedItem = null;
      this.editedIndex = -1;
    },
    save() {
      this.editedItem.PlanIdentityId = this.planIdentityId;
      if (this.editedIndex > -1) {
        this.update();
      } else {
        this.add();
      }
    },
    async update() {
      this.editedItem.Name = this.editedItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      this.editedItem.UniqueIdentifier = this.editedItem.Name;
      this.provider.items[this.editedIndex] = JSON.parse(
        JSON.stringify(this.editedItem)
      );
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("changed", this.provider.items);
    },
    async add() {
      this.editedItem.Name = this.editedItem.Translations.filter(
        (o) => o.LanguageCode === this.language.language
      )[0].Name;
      this.editedItem.UniqueIdentifier = this.editedItem.Name;
      this.provider.items.push(JSON.parse(JSON.stringify(this.editedItem)));
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit("changed", this.provider.items);
    },
    async tryDelete() {
      this.provider.items.splice(this.editedIndex, 1);
      this.deleteDialog = false;
      this.editedItem = null;
      this.editedIndex = -1;
      this.$refs.table.getDataAsync();
      this.$emit("changed", this.provider.items);
    },
  },
};
</script>
